import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { HeaderComponent } from "../header/header.component";
import { LeftnavComponent } from "../leftnav/leftnav.component";
import { FooterComponent } from '../footer/footer.component';
import { RightContainerComponent } from "../right-container/right-container.component";

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, HeaderComponent, LeftnavComponent, FooterComponent, RightContainerComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit, OnDestroy {
  pageHeading = 'Dashboard';
  showLayout = true;
  private routerSub!: Subscription;

  constructor(private router: Router) { }

  private updateLayoutAndHeading(url: string): void {
    const path = url.split('?')[0].split('#')[0];
    this.showLayout = !path.includes('/no-access');
    if (path.includes('home')) {
      this.pageHeading = 'Dashboard';
    } else if (path.includes('timesheet')) {
      this.pageHeading = 'Time Sheet';
    } else {
      this.pageHeading = 'Dashboard';
    }
  }


  ngOnInit(): void {
    // 初期表示時の判定
    this.updateLayoutAndHeading(this.router.url);
    
    // 以降の遷移時の判定
    this.routerSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => {
        this.updateLayoutAndHeading(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }
}
